import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../context/ToastContext";
import { isV2 } from "../../lib/config";
import { printDocument } from "../../lib/printDocument";

/** One-click print of a generated document: silent in the Electron POS, the browser's dialog otherwise. */
export function PrintButton({ path, children, className = "btn-ghost", disabled }: { path: string; children?: ReactNode; className?: string; disabled?: boolean }) {
  const { t } = useTranslation();
  const { toast, toastError } = useToast();
  const [busy, setBusy] = useState(false);
  if (!isV2()) return null; // the printable-page endpoint is part of the v2 API
  async function run() {
    setBusy(true);
    try {
      const how = await printDocument(path);
      if (how === "silent") toast(t("hw.docSent"), "success");
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  }
  return (
    <button type="button" className={className} disabled={busy || disabled} onClick={run} aria-busy={busy}>
      {busy ? <span aria-hidden>⏳</span> : <span aria-hidden>🖨️</span>}
      {children ?? t("hw.print")}
    </button>
  );
}
